import React, { ReactNode } from "react";
import cx from "classnames";

import styles from "./index.module.scss";

interface TextProps {
  children: ReactNode;
  className?: string;
  variant?: "XL" | "L" | "M" | "S" | "XS";
}

const Text: React.FC<TextProps> = ({
  children,
  className = "",
  variant = "L",
}) => {
  return <p className={cx(styles[variant], className)}>{children}</p>;
};

export default Text;
